export const removeUrlQueryString = (inputString: string): string => {
  const queryStringIndex = inputString.indexOf('?');

  if (queryStringIndex !== -1) {
    return inputString.substring(0, queryStringIndex);
  } else {
    return inputString;
  }
};
